/**
 * Created by mnaughton on 10/20/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
export default BaseFieldView.extend({
  template: _.template(
    '<a href="mailto:<%-value%>" data-value="<%-value%>"><%-value%></a>'
  ),

  getControlValue: function () {
    return this.$("a").data("value");
  },

  setControlValue: function () {
    this.render();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/EmailView.js
// module id = 852
// module chunks = 1